import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

interface CountryCityData {
  country: string;
  cities: string[];
}

interface CountriesApiResponse {
  error: boolean;
  msg: string;
  data: CountryCityData[];
}

export const locationApi = createApi({
  reducerPath: 'locationApi',
  baseQuery: fetchBaseQuery({ baseUrl: 'https://countriesnow.space/api/v0.1' }),
  endpoints: (builder) => ({
    getCountriesWithCities: builder.query<CountryCityData[], void>({
      query: () => '/countries',
      transformResponse: (response: CountriesApiResponse) => response.data || [],
      keepUnusedDataFor: 3600, // cache for 1 hour
    }),
  }),
});

export const { useGetCountriesWithCitiesQuery } = locationApi;
